import React from 'react';
import { useLocation, useMatch, useNavigate } from 'react-router-dom';
import { paths } from '@/app/paths';
import { FolioDrawer } from '@/components/Drawers/FolioDrawer';
import { BrokerGroupForm } from './BrokerGroupForm';

const LIST_PATH = `${paths.admin}/broker-groups`;

/**
 * Edit drawer for one broker group, open while the URL is
 * /admin/broker-groups/:brokerGroupId (a row click). Always rendered by the list page, not
 * by the route, so FolioDrawer can animate opening and closing. Closing goes back to the
 * list, keeping its search. A click outside or Escape asks before closing with unsaved
 * changes (FolioDrawerFormGuard in the form).
 */
export const BrokerGroupDrawer = () => {
	const brokerGroupId = useMatch(`${LIST_PATH}/:brokerGroupId`)?.params.brokerGroupId;
	const navigate = useNavigate();
	const { search } = useLocation();

	const handleClose = () => navigate({ pathname: LIST_PATH, search });

	return (
		<FolioDrawer open={Boolean(brokerGroupId)} onClose={handleClose}>
			{brokerGroupId && (
				<BrokerGroupForm
					key={brokerGroupId}
					brokerGroupId={brokerGroupId}
					onClose={handleClose}
				/>
			)}
		</FolioDrawer>
	);
};
